import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ConfirmationFaq from "./component";

const mapStateToProps = ({
    user: {
        isLoggedIn,
        userId
    },
    location: {cityInfo: { city_name: cityName, city_id: cityId } }

}) => ({
    isLoggedIn,
    userId,
    cityName,
    cityId
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationFaq);
